import React, { useContext } from 'react';
import { EventParticipationsContext } from '../../Service/Context/EventParticipationContextV2';

export const CustomerContextInjection = ({ children }) => {
  const { customer, changeCustomer } = useContext(EventParticipationsContext);

  return React.cloneElement(children, {
    entity: customer,
    changeHandler: changeCustomer,
  });
};
